/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Section: Rooms
 */

import { useState } from 'react';
import { Col, Container, Modal, Row } from 'react-bootstrap';
// import { isMobile, BrowserView, MobileView } from "react-device-detect";

// Components
import RoomCard from './RoomCard';
import SingleRoom from './SingleRoom';

const Rooms = (props) => {
    const rooms = props.rooms;

    // Handle Modal Visibility
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Handle Modal Opening
    const [activeRoom, setActiveRoom] = useState(null);
    const handleOnClick = (room) => {
        setActiveRoom(room);
        handleShow();
    };

    return(
        <Container className="pb-5">
            <Row xs={1} lg={2}>
                {rooms.map((room, idx) => {
                    return(
                        <Col key={idx}>
                            <RoomCard room={room} onClick={() => handleOnClick(room)}/>
                            
                            {/* <BrowserView>
                            </BrowserView>
                            <MobileView onClick={() => handleOnClick(room)}>
                                <RoomCard room={room}/>
                            </MobileView> */}
                        </Col>
                    );
                })}
            </Row>
            <Modal
                show={show}
                onHide={handleClose}
                // centered
                fullscreen={"sm-down"}
                size="xl"
            >                
                <Modal.Header closeButton />
                
                <Modal.Body>
                    <SingleRoom room={activeRoom} />
                </Modal.Body>
            </Modal>
        </Container>
    );
}

export default Rooms;